import { render, staticRenderFns } from "./EgresoFormCategoria.vue?vue&type=template&id=2d655e86&scoped=true&"
import script from "./EgresoFormCategoria.vue?vue&type=script&lang=js&"
export * from "./EgresoFormCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d655e86",
  null
  
)

export default component.exports